import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue-demi';
import TextFormatter from '@tencent/wphk-components-text-formatter/index.vue';
import { ArrowUpIcon, ArrowDownIcon, GiftIcon } from '@tencent/wphk-icon-vue';
import AccordionSkeleton from './addcordion-skeleton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'accordion',
  props: {
    campaignId: null
  },
  setup(__props: any, { expose }) {



const accordionHeaderState = ref<boolean>(true);
const accordionBodyState = ref<boolean>(false);
const titleInfo = ref<string>('');
const titleState = computed(() => titleInfo.value.length > 0);
// 展开和折叠
const toggle = () => accordionBodyState.value = !accordionBodyState.value;

/* 折叠头部的显示和隐藏 */
const toggleAccordionHeader = (item: boolean) => accordionHeaderState.value = item;
/* 设置折叠头信息 */
const setTitleInfo = (item: string) => titleInfo.value = item;
/* 折叠内容的显示和隐藏 */
const toggleAccordion = (item: boolean) => accordionBodyState.value = item;

expose({
  toggleAccordionHeader,
  toggleAccordion,
  setTitleInfo,
});

return { __sfc: true,accordionHeaderState, accordionBodyState, titleInfo, titleState, toggle, toggleAccordionHeader, setTitleInfo, toggleAccordion, TextFormatter, ArrowUpIcon, ArrowDownIcon, GiftIcon, AccordionSkeleton }
}

})